import { toast } from "react-toastify";
import { notifySuccess } from "src/assets/toastService";
import { buildInvoiceHtml } from "../../home/Done/hooks/invoiceTemplate";
import api from "src/features/auth/axiosConfig";
import { Order } from "src/shared/services/interfacev2";
import { generatePdf } from "src/business-types/laundry/modules/home/Done/hooks/pdfUtils";

export const SendMail = { Blue: "blue", name: "Send Mail" };
export const SendMessage = { Blue: "blue", name: "Send Message" };
export const COMPLETE = { Blue: "blue", name: "COMPLETE" };
export const CANCEL = { Cancel: "red", name: "CANCEL" };
export const Update = { Blue: "blue", name: "update" };
export const YESCANCEL = { Blue: "blue", name: "Confirm" };
export const Cancel = { Cancel: "red", name: "Cancel" };

export const date = (setTime: (time: { hours: string; minutes: string; seconds: string; day: string; month: string; year: string }) => void) => {
  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  setTime({ hours: hours, minutes: minutes, seconds: seconds, day: day, month: month, year: year });
};
export const orderback = (orderid: string) => {
  window.location.href = `/pos/v1/order-details/${orderid}`;
};
export const Doneorder = (setConfirm?: (val: boolean) => void, getOrdersIn?: () => void) => {
  notifySuccess("The order has been taken successfully");

  setTimeout(() => {
    if (setConfirm) {
      setConfirm(false);
    }
    if (getOrdersIn) {
      getOrdersIn();
    }
  }, 1000);
};
export const formatNumber = (num: number): string => {
  return num.toFixed(2);
};
export const formatNumbers = (num: any): string => {
  const parsed = Number(num);
  if (isNaN(parsed)) return "NaN";
  return parsed.toFixed(2);
};
export const OrderUpdate = ({
  getorder,
  condition,
  inputValue,
  outstangingamount,
  time,
  Payment,
}: {
  getorder: Order | undefined;
  condition: number;
  inputValue: number;
  outstangingamount: number;
  time: { year: string; month: string; day: string; hours: string; minutes: string; seconds:string; };
  Payment: string;
}) => {
  const currentDate = new Date();
  const TOTALAMOUNT = Number(getorder?.orders[0].finalAmount || 0);
  const RESAMOUNT = Number(getorder?.orders[0].receivedAmount) + condition;
  let ReceivedAmount = 0;
  let RemainingAmount = 0;
  if (TOTALAMOUNT >= RESAMOUNT) {
    ReceivedAmount = condition;
    RemainingAmount = TOTALAMOUNT - RESAMOUNT;
  } else {
    ReceivedAmount = Number(getorder?.orders[0].remainingAmount);
    RemainingAmount = 0;
  }
  return {
    finalAmount: TOTALAMOUNT,
    remainingAmount: RemainingAmount,
    orderStatus: "Delivered",
    date: `${time.year}-${time.month}-${time.day}`,
    time: `${time.hours}:${time.minutes}:${time.seconds}`,
    // deliveryDate: `${time.year}-${time.month}-${time.day}`,
    // deliveryTime: `${time.hours}:${time.minutes}:${time.seconds}`,
    // paymentMethod: Payment,
    // receivedAmount: ReceivedAmount,
    payments: { paymentMethod: Payment, receivedAmount: inputValue },
    paymentHistory: [{ paymentMethod: Payment, receivedAmount: ReceivedAmount }],
    // paymentHistory: [...(getorder?.payments || []), { Paymentmethod: Payment, ReceivedAmount: ReceivedAmount }],
    customerId: getorder?.orders[0].customerId || "",
    outstandingBalance: outstangingamount,
    newOrderAmount: 0,
    orderDate: `${time.year}-${time.month}-${time.day}`,
    orderTime: `${time.hours}:${time.minutes}:${time.seconds}`,
  };
};

export const orderemailmsg = async (
  getorder: Order,
  email: string,
  ResAmount: string,
  id: string,
  Tamount: number,
  Ramount: string,
  handleDone: () => void
) => {
  const toastId3 = toast.loading("Waiting...", { position: "top-right", autoClose: 2000, theme: "colored" });
  const htmlContent = buildInvoiceHtml({
  CustomerName: getorder?.customerDetails.firstName || "Valued Customer",
  orderDate: String(getorder?.orders[0].orderedOn ?? ""),
  products: getorder?.orderDetails[0].products.map((product) => ({
    ...product,
    productName: product.name || "",
    totalPrice: product.lineTotal || 0,
  })),
  totalAmount: getorder?.orders[0].orderAmount ?? 0,
});

  const pdfBlob = await generatePdf(htmlContent);
  try {
    const formData = new FormData();
    formData.append("file", pdfBlob, "Invoice.pdf");
    formData.append("receiver_email", email);
    formData.append("cnames", getorder.customerDetails.firstName || "Valued Customer");
    formData.append("id", getorder?.orders[0].orderId);
    formData.append("TotalAmount", String(getorder.orders[0].orderAmount ?? 0));
    formData.append("ReceivedAmount", String(getorder.paymentHistory[0].receivedAmount));
    formData.append("RemainingAmount", String(getorder.orders[0].remainingAmount ?? 0));

    await api.post(`/app/pos/v2/orders_send_email`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    toast.dismiss(toastId3);
    toast.success("Mail sent successfully", { autoClose: 2000 });
    handleDone();
  } catch (err) {
    toast.dismiss(toastId3);
    toast.error("Failed to send email", { autoClose: 2000 });
    console.error(err);
  }
};
